"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getClassNames = exports.APP_BAR_HEIGHT = exports.APP_BAR_PIXEL_HEIGHT = void 0;

var _react = require("@fluentui/react");

var APP_BAR_PIXEL_HEIGHT = 50;
exports.APP_BAR_PIXEL_HEIGHT = APP_BAR_PIXEL_HEIGHT;
var APP_BAR_HEIGHT = '50px';
exports.APP_BAR_HEIGHT = APP_BAR_HEIGHT;
var getClassNames = (0, _react.memoizeFunction)(function (theme) {
  var semanticColors = theme.semanticColors;
  return {
    root: (0, _react.mergeStyles)({
      height: APP_BAR_HEIGHT,
      background: semanticColors.headerBackground || theme.palette.black,
      backgroundImage: semanticColors.headerBackgroundImage,
      display: 'flex',
      flex: '1'
    })
  };
});
exports.getClassNames = getClassNames;